<ng-container *ngIf="wizardData$ | async as wizardData">
  <app-wizard [data]="wizardData" class="project-import-wizard"> </app-wizard>
</ng-container>
